var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 5.5C8.5 5.76522 8.60536 6.01957 8.79289 6.20711C8.98043 6.39464 9.23478 6.5 9.5 6.5C9.76522 6.5 10.0196 6.39464 10.2071 6.20711C10.3946 6.01957 10.5 5.76522 10.5 5.5C10.5 5.23478 10.3946 4.98043 10.2071 4.79289C10.0196 4.60536 9.76522 4.5 9.5 4.5C9.23478 4.5 8.98043 4.60536 8.79289 4.79289C8.60536 4.98043 8.5 5.23478 8.5 5.5Z",
    stroke: "#4E81F7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 12.5C8.5 12.7652 8.60536 13.0196 8.79289 13.2071C8.98043 13.3946 9.23478 13.5 9.5 13.5C9.76522 13.5 10.0196 13.3946 10.2071 13.2071C10.3946 13.0196 10.5 12.7652 10.5 12.5C10.5 12.2348 10.3946 11.9804 10.2071 11.7929C10.0196 11.6054 9.76522 11.5 9.5 11.5C9.23478 11.5 8.98043 11.6054 8.79289 11.7929C8.60536 11.9804 8.5 12.2348 8.5 12.5Z",
    stroke: "#4E81F7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 19.5C8.5 19.7652 8.60536 20.0196 8.79289 20.2071C8.98043 20.3946 9.23478 20.5 9.5 20.5C9.76522 20.5 10.0196 20.3946 10.2071 20.2071C10.3946 20.0196 10.5 19.7652 10.5 19.5C10.5 19.2348 10.3946 18.9804 10.2071 18.7929C10.0196 18.6054 9.76522 18.5 9.5 18.5C9.23478 18.5 8.98043 18.6054 8.79289 18.7929C8.60536 18.9804 8.5 19.2348 8.5 19.5Z",
    stroke: "#4E81F7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 5.5C14.5 5.76522 14.6054 6.01957 14.7929 6.20711C14.9804 6.39464 15.2348 6.5 15.5 6.5C15.7652 6.5 16.0196 6.39464 16.2071 6.20711C16.3946 6.01957 16.5 5.76522 16.5 5.5C16.5 5.23478 16.3946 4.98043 16.2071 4.79289C16.0196 4.60536 15.7652 4.5 15.5 4.5C15.2348 4.5 14.9804 4.60536 14.7929 4.79289C14.6054 4.98043 14.5 5.23478 14.5 5.5Z",
    stroke: "#4E81F7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 12.5C14.5 12.7652 14.6054 13.0196 14.7929 13.2071C14.9804 13.3946 15.2348 13.5 15.5 13.5C15.7652 13.5 16.0196 13.3946 16.2071 13.2071C16.3946 13.0196 16.5 12.7652 16.5 12.5C16.5 12.2348 16.3946 11.9804 16.2071 11.7929C16.0196 11.6054 15.7652 11.5 15.5 11.5C15.2348 11.5 14.9804 11.6054 14.7929 11.7929C14.6054 11.9804 14.5 12.2348 14.5 12.5Z",
    stroke: "#4E81F7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 19.5C14.5 19.7652 14.6054 20.0196 14.7929 20.2071C14.9804 20.3946 15.2348 20.5 15.5 20.5C15.7652 20.5 16.0196 20.3946 16.2071 20.2071C16.3946 20.0196 16.5 19.7652 16.5 19.5C16.5 19.2348 16.3946 18.9804 16.2071 18.7929C16.0196 18.6054 15.7652 18.5 15.5 18.5C15.2348 18.5 14.9804 18.6054 14.7929 18.7929C14.6054 18.9804 14.5 19.2348 14.5 19.5Z",
    stroke: "#4E81F7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrag);
export default __webpack_public_path__ + "static/media/Drag.69c528d80e155c73587237208d6a7486.svg";
export { ForwardRef as ReactComponent };